---
title: Docker in the VM
lede: A Docker daemon inside a session's own micro-VM, for work that needs containers.
order: 38
part: Shape the machine
---

Turn it on and each micro-VM session gets its own Docker daemon: for a test suite that starts a database, a Compose stack, Testcontainers, or a build that runs in a container. It is **Off** by default.

![The container runtime setting](media/docker.webp)

### Turn it on

- For every workspace: **Settings › Sandbox › Container runtime**, set **Docker** to **On, inside the VM**.
- For one workspace: **Workspace settings › Sandbox › Resources**, **Override** on **Container runtime**.

It applies to sessions started afterwards. Docker Hub and Ubuntu's package hosts are added to the session's allowed hosts while it is on.

:::note The Docker on your computer is never reached
Your computer's Docker socket is not mounted or forwarded. A container started in a session lives in that session's VM and is gone with it.
:::

### The Docker disk

Each session gets a separate disk for its images, containers and build cache, so a runaway build fills that disk and not the VM's own. **Docker disk**, shown once Docker is on, sets its size: 20 GB by default, from 5 to 500 GB. It is created with the session, removed with it, and does not count against the VM's **Disk**.

### When the machine starts again

Allowing a new host starts the session's machine again, and so does opening a parked session. Docker comes back with it, on the same disk: your images are still there, and the containers that were running start again, with or without a restart policy. What they held in memory is gone, as after any restart. If Docker or a container can't come back, a message says so and the session stays up.

### What it costs

A daemon and its images per session, and every session starts with a fresh daemon, so the first run pulls its images again. Turn it on only for the workspaces that need it.
